// src/components/FloatingCircle/FloatingCircle.js
import React, { useState } from 'react';
import { HelpIcon, MegaPhoneIcon } from '../../assets/icons/icons';
import FloatingModal from '../FloatingModal/FloatingModal';
import './style.css';

export default function FloatingCircle({
  modalTitle = 'Need Assistance?',
  modalContent = <p>Here’s some helpful text...</p>,
  openModal
}) {
  const [isOpen, setIsOpen] = useState(openModal);
  const toggle = () => setIsOpen(o => !o);

  return (
    <>
      <button
        className="floating-circle"
        onClick={toggle}
        aria-label="Help"
      >
        <MegaPhoneIcon className="floating-icon" />
      </button>

      <FloatingModal
        isOpen={isOpen}
        onRequestClose={toggle}
        title={modalTitle}
      >
        {modalContent}
      </FloatingModal>
    </>
  );
}
